var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAlerts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 0.9,
    width: 25.2,
    height: 25.2,
    rx: 12.6,
    fill: "#08C296"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 0.9,
    width: 25.2,
    height: 25.2,
    rx: 12.6,
    stroke: "#19213E",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5315 7.83984H19.3028C19.1306 7.83984 18.9671 7.91895 18.8616 8.0543L11.6142 17.2354L8.13896 12.832C8.08638 12.7653 8.01938 12.7113 7.94296 12.6742C7.86655 12.637 7.78271 12.6177 7.69774 12.6176H6.46903C6.35126 12.6176 6.28622 12.7529 6.35829 12.8443L11.1729 18.9439C11.3979 19.2287 11.8304 19.2287 12.0571 18.9439L20.6423 8.06484C20.7143 7.9752 20.6493 7.83984 20.5315 7.83984Z",
    fill: "#19213E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAlerts);
export default __webpack_public_path__ + "static/media/no-alerts.0be7f206fb981b37f11b6763f256bd38.svg";
export { ForwardRef as ReactComponent };